import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ImsDataService } from "./services/initializeAndRefresh/imsDataService";
import moment from "moment";
import { ForecastService } from "./services/forecastService";

(function (module) {
    "use strict";
    module.controller("ForecastEditCtrl", [
        "$scope",
        "$window",
        ForecastService.componentName,
        ImsDataService.componentName,
        "forecastInitializationService",
        "modalService",
        "$state",
        "$stateParams",
        "forecastMetadata",
        "imsLatestData",
        "WizardHandler",
        angularServicesNames.$translate,
        "$timeout",
        "$uibModal",
        "forecastCacheService",
        "AlertService",
        "$rootScope",
        "$log",
        "$sce",
        "stepValidationService",
        "forecastMLModelUpdateService",
        "volumeToValueService",
        ForecastCtrl
    ]);

    function ForecastCtrl(
        this: $TSFixMe,
        $scope: $TSFixMe,
        $window: ng.IWindowService,
        forecastService: ForecastService,
        imsDataService: ImsDataService,
        forecastInitializationService: $TSFixMe,
        modalService: $TSFixMe,
        $state: ng.ui.IStateService,
        $stateParams: ng.ui.IStateParamsService,
        forecastMetadata: $TSFixMe,
        imsLatestData: $TSFixMe,
        WizardHandler: $TSFixMe,
        $translate: ng.translate.ITranslateService,
        $timeout: ng.ITimeoutService,
        $uibModal: ng.ui.bootstrap.IModalService,
        forecastCacheService: $TSFixMe,
        AlertService: AlertService,
        $rootScope: ng.IRootScopeService,
        $log: ng.ILogService,
        $sce: ng.ISCEService,
        stepValidationService: $TSFixMe,
        forecastMLModelUpdateService: $TSFixMe,
        volumeToValueService: $TSFixMe
    ) {
        const $ctrl = this;

        $scope.forecast = forecastMetadata.jsonData;
        $scope.forecastId = forecastMetadata.id;
        forecastCacheService.setForecast($scope.forecast);

        forecastMetadata.jsonData = undefined;
        $scope.forecastMetadata = forecastMetadata;
        $scope.isForecastDirty = false;
        $ctrl.autoSaveDelay = 30;

        $scope.$on("notify-after-ml-calculation", function (event: $TSFixMe, any: $TSFixMe) {
            const forecastUId = forecastMLModelUpdateService.getForecastIUdFromModelId(any.modelId.ModelId);
            if (forecastUId.toLowerCase() != $scope.forecastMetadata.uId.toLowerCase()) {
                return;
            }

            $log.debug(`[${new Date().toISOString()}] Recived calculation finished: ${any.modelId.ModelId}`);
            forecastMLModelUpdateService.updateMlModelFitDone(
                any.modelId.ModelId,
                $scope.forecast,
                $scope.forecastMetadata
            );
            forecastService.save($stateParams.id, $scope.forecast).then(function (data: $TSFixMe) {
                $scope.forecastMetadata = data;
                $scope.isForecastDirty = false;
                $log.info(
                    `Forecast draft saved. Next save in ${
                        $ctrl.autoSaveDelay
                    } seconds. [${new Date().toLocaleTimeString()}]`
                );

                if (forecastMLModelUpdateService.areAllMlModelReady($scope.forecast)) {
                    AlertService.success($translate.instant("FORECAST.MACHINE_LEARNING_ALL_COMPLETED"));
                } else {
                    AlertService.success($translate.instant("FORECAST.MACHINE_LEARNING_NEW_MODEL"));
                }
            });
        });

        $scope.$on("refresh-ml-models", () => refreshMlModels());

        if (
            $scope.forecast &&
            $scope.forecast.market &&
            $scope.forecastMetadata.isEditable &&
            !forecastMLModelUpdateService.areAllMlModelReady($scope.forecast)
        ) {
            refreshMlModels();
        }

        function refreshMlModels() {
            forecastService.loadMarketMlModels($scope.forecastId).then((mlModels: $TSFixMe) => {
                let isChanged = false;
                for (const mlModel of mlModels) {
                    // @ts-expect-error ts-migrate(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
                    isChanged |= forecastMLModelUpdateService.updateMlModelFitDone(
                        mlModel,
                        $scope.forecast,
                        $scope.forecastMetadata
                    );
                }
                forecastService.save($stateParams.id, $scope.forecast).then(function (data: $TSFixMe) {
                    $scope.forecastMetadata = data;
                    $scope.isForecastDirty = false;
                    $log.info(
                        `Forecast draft saved. Next save in ${
                            $ctrl.autoSaveDelay
                        } seconds. [${new Date().toLocaleTimeString()}]`
                    );

                    if (forecastMLModelUpdateService.areAllMlModelReady($scope.forecast)) {
                        AlertService.success($translate.instant("FORECAST.MACHINE_LEARNING_ALL_COMPLETED"));
                    } else if (isChanged) {
                        AlertService.warning($translate.instant("FORECAST.MACHINE_LEARNING_SOME_MISSING"));
                    }
                });
            });
        }

        $ctrl.showComment = () =>
            forecastMetadata.correctionComment && forecastMetadata.status === "ReturnedToCorrection";

        $scope.imsLatestData = imsLatestData;

        $ctrl.additionalTabs = [
            {
                headerKey: "FORECAST.VOLUME_TO_VALUE.HEADER",
                template: "volumeToValueTranslation.html",

                isDisabled: () => angular.isUndefinedOrNull($scope.forecast.market.forecast.pmForecast)
            }
        ];

        function displayDuplicatedErrorMessage(duplicatedIndexes: $TSFixMe) {
            var text = $translate.instant("FORECAST.PARAMETERS.MODAL_CONFIRMATION_DUPLICATED_BEGIN") + "<br/>";
            for (const duplicatedIndex in duplicatedIndexes) {
                text += " " + duplicatedIndex + ":  " + duplicatedIndexes[duplicatedIndex].join() + "<br/>";
            }
            text += $translate.instant("FORECAST.PARAMETERS.MODAL_CONFIRMATION_DUPLICATED_END") + "<br/>";
            text += $translate.instant("FORECAST.PARAMETERS.MODAL_CONFIRMATION_TEXT");

            return text;
        }

        $scope.stepOne = {
            isDone: !angular.equals($scope.forecast, {}),
            nextStep: function () {
                if ($scope.stepOne.isParametersValid == false) {
                    $scope.stepOne.showValidationErrors();
                } else {
                    if ($scope.stepOne.isDone == false) {
                        var duplicatedIndex = forecastInitializationService.findDuplicatedOracleIndex($scope.forecast);
                        modalService.showConfirmationModalStr(
                            _.some(duplicatedIndex)
                                ? displayDuplicatedErrorMessage(duplicatedIndex)
                                : $translate.instant("FORECAST.PARAMETERS.MODAL_CONFIRMATION_TEXT"),
                            () => {
                                $scope.promiseHandler = forecastInitializationService
                                    .initializeForecast($stateParams.id, $scope.forecast, $scope.forecastMetadata.uId)
                                    .then(() => {
                                        const name = computeDefaultForecastName(
                                            $scope.forecast,
                                            $scope.forecastMetadata
                                        );
                                        $scope.promiseHandler = forecastService
                                            .initialize($stateParams.id, $scope.forecast, name)
                                            .then(() => {
                                                $scope.forecastMetadata.name = name;
                                                $scope.stepOne.lockForEdition();
                                                $scope.stepOne.isDone = true;
                                                WizardHandler.wizard().next();
                                                $scope.actions.resetAutoSave();
                                            });
                                    });
                            }
                        );
                    } else {
                        WizardHandler.wizard().next();
                    }
                }
            }
        };

        $scope.canExitAssumptionsStep = () => $scope.stepTwo.isValid;
        $scope.canExitParametersStep = () => $scope.stepOne.isDone;

        $scope.stepTwo = {
            next: () => {
                if ($scope.stepTwo.isValid) {
                    WizardHandler.wizard().next();
                } else {
                    $scope.stepTwo.showValidationErrors();
                    AlertService.warning($translate.instant("FORECAST.PARAMETERS.PARAMETERS_WARNING_MESSAGE"));
                }
            }
        };
        $scope.stepThree = {
            isDone: () =>
                angular.isDefined($scope.forecast) &&
                angular.isDefined($scope.forecast.market) &&
                angular.isDefined($scope.forecast.market.forecast) &&
                angular.isDefined($scope.forecast.market.forecast.pmForecast),
            canEnter: () => $scope.stepTwo.isValid,
            next: () => {
                if (!$scope.stepThree.isDone()) {
                    AlertService.warning($translate.instant("FORECAST.STEP_THREE_NO_FORECAST"));
                } else {
                    WizardHandler.wizard().next();
                }
            }
        };

        $scope.stepForecastSku = {
            canEnter: () => $scope.stepThree.isDone(),
            validationError: "",
            isDone() {
                $scope.stepForecastSku.validationError = stepValidationService.getSkuStepValidionError(
                    $scope.forecast.parameters.forecastMethod.methodId,
                    $scope.forecast
                );
                return !$scope.stepForecastSku.validationError;
            }
        };

        $scope.stepSummary = {
            canEnter: () => $scope.stepForecastSku.isDone()
        };

        var initializingWatch = true;
        $scope.$watch(
            "forecast",
            function () {
                if (initializingWatch) {
                    $timeout(function () {
                        initializingWatch = false;
                    });
                } else {
                    $scope.isForecastDirty = true;
                }
            },
            true
        );

        $scope.actions = {
            cancel: () => $window.history.back(),
            saveDraft: function () {
                if ($scope.stepOne.isDone == false) {
                    $log.info(
                        `Parameters are not set.  Save skipped. Next save attempt in ${
                            $ctrl.autoSaveDelay
                        } seconds. [${new Date().toLocaleTimeString()}]`
                    );
                } else if ($scope.isForecastDirty == false) {
                    $log.info(
                        `Forecast in not modified. Save skipped. Next save attempt in ${
                            $ctrl.autoSaveDelay
                        } seconds. [${new Date().toLocaleTimeString()}]`
                    );
                } else {
                    $log.info(`Forecast saving draft... [${new Date().toLocaleTimeString()}]`);
                    forecastService.save($stateParams.id, $scope.forecast).then(function (data: $TSFixMe) {
                        $scope.forecastMetadata = data;
                        $scope.isForecastDirty = false;
                        $log.info(
                            `Forecast draft saved. Next save in ${
                                $ctrl.autoSaveDelay
                            } seconds. [${new Date().toLocaleTimeString()}]`
                        );
                    });
                }
            },
            saveDraftByUser: function () {
                $scope.actions.resetAutoSave();
                return ($scope.promiseHandler = forecastService
                    .save($stateParams.id, $scope.forecast)
                    .then(function (data: $TSFixMe) {
                        $scope.forecastMetadata = data;
                        $scope.isForecastDirty = false;
                        AlertService.success($translate.instant("SAVE_DRAFT_SUCCESS"));
                    }));
            },
            saveApproved: function () {
                modalService.showConfirmationModal("FORECAST.CONFIRM_SAVE_APPROVED", () => {
                    $scope.promiseHandler = forecastService.save($stateParams.id, $scope.forecast).then(() => {
                        // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'data'.
                        $scope.forecastMetadata = data;
                        $scope.isForecastDirty = false;
                        AlertService.success($translate.instant("SAVE_APPROVED_SUCCESS"));
                    });
                });
            },
            saveAsNew: function () {
                var modalInstance = $uibModal.open({
                    component: "forecastSaveAsNew",
                    resolve: {
                        forecastId: function () {
                            return $stateParams.id;
                        },
                        name: function () {
                            return $scope.forecastMetadata.name;
                        }
                    }
                });
                modalInstance.result.then(function (result: $TSFixMe) {
                    $scope.promiseHandler = forecastService
                        .saveAsNew($stateParams.id, result)
                        .then(function (forecastId: $TSFixMe) {
                            $state.go("forecast.edit", {
                                id: forecastId
                            });
                        });
                });
            },
            updateForecastName: function (name: $TSFixMe) {
                return forecastService.updateName($stateParams.id, name).then(function (response) {
                    if (response.status == 500) {
                        return $translate.instant("GENERIC_ERROR");
                    }
                    if (!response.data) {
                        return $translate.instant("FORECAST.WIZARD.NAME_USED");
                    }

                    $scope.forecastMetadata = response.data;
                    return true;
                });
            },
            remove: function () {
                $scope.promiseHandler = forecastService.remove($stateParams.id).then(function (data: $TSFixMe) {
                    $state.go("forecast.list");
                });
            }
        };

        $scope.$on("wizard:stepChanged", function (event: $TSFixMe, args: $TSFixMe) {
            $scope.stepNumber = args.index;
            if (args.index == 1 && typeof $scope.stepTwo.stepEnter === "function") {
                $scope.stepTwo.stepEnter();
            }
            if (args.index == 2 && typeof $scope.stepThree.stepEnter === "function") {
                $scope.stepThree.stepEnter();
            }
            $rootScope.$broadcast("forecastWizard:stepChanged", args);
        });

        if ($scope.stepOne.isDone) {
            $ctrl.productForecastStepIndex = $scope.forecast.parameters.forecastMethod.methodId == "sku" ? 4 : 3;
        }

        $ctrl.onPriceChangeInYearsChanged = (forecast: $TSFixMe, parameters: $TSFixMe) => {
            volumeToValueService.priceChangeInYearsChanged(forecast, parameters);
        };

        $ctrl.isSkuStepAvailable = () =>
            $scope.stepOne.isDone && ["sku", "chamfering"].includes($scope.forecast.parameters.forecastMethod.methodId);
        $ctrl.isMarketStepAvailable = () =>
            $scope.stepOne.isDone && ["sku", "mktsh"].includes($scope.forecast.parameters.forecastMethod.methodId);
        $ctrl.canExitSkuForecast = () => !$ctrl.isSkuStepAvailable() || $scope.stepForecastSku.isDone();

        function computeDefaultForecastName(forecast: $TSFixMe, forecastMetadata: $TSFixMe) {
            const version = angular.isUndefinedOrNull(forecast.market.version) ? "" : `${forecast.market.version} `;

            const creationTime = moment(forecastMetadata.creationTime).format("YYYY-MM-DD H:mm:ss");

            return `${forecast.market.name} ${version}- ${_.pluck(forecast.market.brands, "name").join(
                ", "
            )} - [${creationTime}]`;
        }
    }
})(angular.module("topline.modules"));
